// extracted by mini-css-extract-plugin
export var quantityInput = "_mf-0";